"use strict";

var _defineProperty = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _exports$alertTokens;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alertTokens = void 0;
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _types = require("./types");
var alertTokens = exports.alertTokens = (_exports$alertTokens = {}, _defineProperty(_exports$alertTokens, _types.AlertType.INFORMATION, {
  background: _tokens.default.sky.comp.toast.color.background.information,
  border: _tokens.default.sky.sys.color.border.active,
  icon: 'info'
}), _defineProperty(_exports$alertTokens, _types.AlertType.SUCCESS, {
  background: _tokens.default.sky.comp.toast.color.background.success,
  border: _tokens.default.sky.sys.color.border.success,
  icon: 'checkCircle'
}), _defineProperty(_exports$alertTokens, _types.AlertType.WARNING, {
  background: _tokens.default.sky.comp.toast.color.background.warning,
  border: _tokens.default.sky.sys.color.border.warning,
  icon: 'warning'
}), _defineProperty(_exports$alertTokens, _types.AlertType.ERROR, {
  background: _tokens.default.sky.comp.toast.color.background.error,
  border: _tokens.default.sky.sys.color.border.error,
  icon: 'error'
}), _exports$alertTokens);